import { NAV_COMPONENT } from '~/constants';
import { useStores } from '~/hooks';
import { isDingTalkPcUA, isLarkUA, isWxWorkUA } from '~/utils';

interface IUseNavItemShowResult {
    isNavCompShow: (comp: string) => boolean;
}

const useNavItemShow = (): IUseNavItemShowResult => {
    const { corpUserStore } = useStores();
    const { isISVEncrypted } = corpUserStore;

    const isNavCompShow = (compName: string) => {
        switch (compName) {
            case NAV_COMPONENT.BROWSER:
                return isISVEncrypted ? false : isDingTalkPcUA() || isWxWorkUA() || isLarkUA();
            case NAV_COMPONENT.MESSAGE:
                // 空企业不展示消息中心图标
                return !corpUserStore.isCurrentUserNoCorp;
            case NAV_COMPONENT.CONTACTS:
                return corpUserStore.hasContactPermission;
            default:
                return true;
        }
    };

    return {
        isNavCompShow
    };
};

export default useNavItemShow;
